document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('variant:change', (event) => {
        const variant = event.detail.variant;
        if (!variant) return;

        let section = document.querySelector('#shopify-section-main-product');
        if (!section) {
            section = event.target.closest('.product-grid');
        }
        if (!section) return;

        // Get all thumbnails and slides
        const thumbnails = section.querySelectorAll('.product-thumbnail');
        const slides = section.querySelectorAll('.product-gallery__slide');

        // Show/hide thumbnails and slides based on variant ID
        thumbnails.forEach(thumbnail => {
            const variantId = thumbnail.getAttribute('data-variant-id');
            thumbnail.classList.toggle('hidden', variantId !== String(variant.id));
        });

        slides.forEach(slide => {
            const variantId = slide.getAttribute('data-variant-id');
            slide.classList.toggle('hidden', variantId !== String(variant.id));
        });
    });
});